import React from 'react';
import styled from 'styled-components';
import { FaGithub, FaLinkedin, FaEnvelope } from 'react-icons/fa';

const Footer = () => {
  return (
    <StyledFooter>
      <FooterContent>
        <SocialLinks>
          <SocialLink href="https://github.com/amritphuyal" target="_blank" rel="noopener noreferrer">
            <FaGithub />
          </SocialLink>
          <SocialLink href="https://www.linkedin.com/in/amritphuyal/" target="_blank" rel="noopener noreferrer">
            <FaLinkedin />
          </SocialLink>
          <SocialLink href="mailto:amritphuyal019@gmail.com">
            <FaEnvelope />
          </SocialLink>
        </SocialLinks>
        <Copyright>
          &copy; {new Date().getFullYear()} Amrit Prasad Phuyal. All rights reserved.
        </Copyright>
      </FooterContent>
    </StyledFooter>
  );
};

// Styled Components
const StyledFooter = styled.footer`
  background-color: var(--primary);
  padding: 2rem 0;
  text-align: center;
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
`;

const SocialLinks = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 1.5rem;
`;

const SocialLink = styled.a`
  color: var(--text-secondary);
  font-size: 1.5rem;
  margin: 0 1rem;
  transition: all 0.3s ease;
  
  &:hover {
    color: var(--accent);
    transform: translateY(-3px);
    filter: drop-shadow(0 3px 5px rgba(30, 136, 229, 0.3));
  }
`;

const Copyright = styled.p`
  color: var(--text-secondary);
  font-size: 0.9rem;
`;

export default Footer;
